/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export class Paragraph {
  constructor(json: JSON | any) {
    Object.assign(this as Paragraph, json)
  }

  id?: string
  rev?: string
  /**
   * hard delete (unix epoch in ms) timestamp of the object. Filled automatically when deletePatient is called.
   */
  deletionDate?: number
  chapterName?: string
  paragraphName?: string
  startDate?: number
  createdTms?: number
  createdUserId?: string
  endDate?: number
  keyStringNl?: string
  keyStringFr?: string
  agreementType?: string
  processType?: number
  legalReference?: string
  publicationDate?: number
  modificationDate?: number
  processTypeOverrule?: string
  paragraphVersion?: number
  agreementTypePro?: string
  modificationStatus?: string
}
